import script from "./Layout2RightSectionTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./Layout2RightSectionTabs.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__